module.exports = __webpack_public_path__ + "img/stethoscope.f1a0386a.svg";